import { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { getAnnouncementList } from "../../../services/ApiGetAnnouncementList";
import { AnnouncementsData, GetAnnouncement } from "../../../model/datatype";
import { useNavigate } from "react-router-dom";
import InfiniteScroll from 'react-infinite-scroll-component';
import Moment from 'moment';
import moment  from 'moment-timezone';
import { useTranslation } from 'react-i18next';

export const AnouncementList = (prop: any) => {
    const timezoneStr = Intl.DateTimeFormat().resolvedOptions().timeZone || 'FallbackTimeZone';
    const [data, setData] = useState<AnnouncementsData | null>(null);
    const [limit, setLimit] = useState(3)
    const [offset, setOffset] = useState(0)
    const [hasMore, setHasMore] = useState(true)
    const [announcementLists, setAnnouncementLists] = useState<[GetAnnouncement] | null>(null);

    let navigate = useNavigate();
    let { t } = useTranslation();
    useEffect(() => {
        //console.log('offset=',offset);
        getAnnouncementList(offset, limit).then((response) => {
            const getData: any = response;
            //console.log(getData.announcements);
            setData(getData);
            if (announcementLists !== null) {
                const result: any = announcementLists.concat(getData.announcements);
                setAnnouncementLists(result);
                if (announcementLists?.length >= getData.totalCount) {
                    setHasMore(false)
                }
            } else {
                setAnnouncementLists(getData.announcements);
            }

        })
    }, [offset]);


    if (localStorage.getItem('Language') === 'en') {
        Moment.locale('en-sg');
    } else {
        Moment.locale('th');
    }


    function hanleMore(item: GetAnnouncement) {
        navigate('/anouncement/' + item.id, { state: item });
    }

    function fetchData() {
        setOffset(announcementLists?.length || 0);
        //console.log('fn fetchData' + typeof (announcementLists?.length));
    }

    return (
        <>
            <Container className="anouncement-layout">
                {
                    (announcementLists !== null) ?
                        (announcementLists?.length > 0) ?
                            <InfiniteScroll
                                dataLength={announcementLists?.length}
                                next={fetchData}
                                hasMore={hasMore}
                                loader={<h4 className="mt-4 text-center">Loading...</h4>}
                                endMessage={
                                    <></>
                                }
                            >

                                {announcementLists?.map((item: GetAnnouncement) => (
                                    <div className="anouncement-box" onClick={() => hanleMore(item)} key={item.id}>
                                        <Row className="mb-3 setMargin mx-0">
                                            <Col className="col-12 col-sm-5 col-md-5 col-lg-5 py-2 px-0">
                                                <div className="images h-100 py-0 px-2 w-100">
                                                    <img src={'data:image/jpg;base64,' + item?.thumnail} alt="" className="rounded img-fluid w-100 h-100" />
                                                </div>
                                            </Col>
                                            <Col className="pl-0 col-12 col-sm-7 col-md-7 col-lg-7 p-relative py-2">
                                                <div className="detail h-auto mb-1 ps-0 announcement-title-text">
                                                    {(localStorage.getItem('Language') === 'th') ? item.subjectTh : item.subjectEn}
                                                </div>
                                                <div className="date date-icon ps-0">
                                                    <img src="../images/calendar-icon.svg" alt="" />
                                                </div>
                                                <div className="icon-date ps-0 post-date">
                                                    {moment(item?.createdDateTime + 'Z').tz(timezoneStr).format('DD MMM YYYY')}
                                                </div>
                                                <div className="shortdesc-text mt-2">
                                                    <p>
                                                        {(localStorage.getItem('Language') === 'th') ? item.shortDetailsTh : item.shortDetailsEn}
                                                    </p>
                                                </div>
                                                <div className="more">
                                                    <Button className="btn-readmore" onClick={() => hanleMore(item)}>{t('more')}..</Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                ))}

                            </InfiniteScroll> :
                            <div className="loader-data text-notfound text-center">{t('text_notfound')}</div>
                        :
                        <div className="loader-data">
                            <div className="spinner"></div>
                        </div>
                }

            </Container >
        </>
    );

};